import { inject, provide, InjectionKey } from "vue";

export type ContactAttachOption = {
	Id: number,
	Name: string
}

/**
 * Контекст блока контактов для текущей страницы.
 *
 * Общие компоненты контактов (ClientsPanelListItem, CreateEditContactDropdown,
 * ContactAddClientDropdown) используются на Главной, Клиенте и Проекте. Мутации
 * существующего контакта (теги, привязка клиента, редактирование) патчат сам
 * объект по ссылке и реактивны на всех страницах. А операции, меняющие СОСТАВ
 * списка (создание/удаление), завязаны на конкретную страницу — для них и нужен
 * этот контекст.
 */
export type ContactsContext = {
	context: "main" | "client" | "project",
	/** Id текущего проекта (страница Проекта) — для статуса главного контакта. */
	readonly projectId?: number | null,
	/** Id клиента, к которому привязывается новый контакт (страница Клиента). */
	readonly attachClientId?: number | null,
	/** Клиенты проекта для селекта привязки в окне создания (страница Проекта). */
	readonly attachClientOptions?: ContactAttachOption[],
	/** Перезапрос текущего отфильтрованного списка контактов страницы. */
	refetchContacts?: () => Promise<void> | void
}

const CONTACTS_CONTEXT: InjectionKey<ContactsContext> = Symbol("contactsContext");

export const provideContactsContext = (value: ContactsContext): void => {
	provide(CONTACTS_CONTEXT, value);
};

export const useContactsContext = (): ContactsContext => {
	return inject(CONTACTS_CONTEXT, { context: "main" });
};
